import { logSSOFlow } from '../../faro/FaroClient';
import { sanitizeUrlForLogging } from '../../faro/utils';

/**
 * Helper to track SSO redirect initiation
 */
export const trackInitiatingSSORedirect = (idpIdentifier: string, orgId: string, email: string, redirectUrl: string) => {
    logSSOFlow({
        stage: 'redirect-initiated',
        idpIdentifier,
        orgId,
        email,
        metadata: {
            redirectUrl: sanitizeUrlForLogging(redirectUrl, { stripQuery: true })
        }
    });
};

/**
 * Helper to track SSO callback success
 */
export const trackSSOCallbackSuccess = (code: string) => {
    const callbackUrl = sanitizeUrlForLogging(window.location.href, { stripQuery: true });

    logSSOFlow({
        stage: 'callback-received',
        success: true,
        metadata: {
            hasCode: true,
            callbackUrl
        }
    });
};

/**
 * Helper to track SSO callback error
 */
export const trackSSOCallbackError = (error: string) => {
    const callbackUrl = sanitizeUrlForLogging(window.location.href, { stripQuery: true });

    logSSOFlow({
        stage: 'callback-received',
        success: false,
        error,
        metadata: {
            callbackUrl
        }
    });
};

/**
 * Helper to track SSO completion
 */
export const trackSSOCompletion = (success: boolean, orgId?: string, error?: string) => {
    logSSOFlow({
        stage: success ? 'completed' : 'failed',
        orgId,
        success,
        error
    });
};

/**
 * Helper to track PKCE challenge generation
 */
export const trackPKCEChallengeGenerated = (success: boolean, error?: string) => {
    logSSOFlow({
        stage: 'pkce-generated',
        success,
        error,
        metadata: {
            timestamp: new Date().toISOString()
        }
    });
};

/**
 * Helper to track SSO authorize URL construction
 */
export const trackAuthorizeURLBuilt = (idpIdentifier: string, email: string, authorizeUrl: string) => {
    const sanitizedUrl = sanitizeUrlForLogging(authorizeUrl, { stripQuery: true });

    logSSOFlow({
        stage: 'authorize-url-built',
        url: sanitizedUrl,
        idpIdentifier,
        email,
        success: true,
        metadata: {
            urlLength: sanitizedUrl.length
        }
    });
};

/**
 * Helper to track Google Social Sign-in initiation
 */
export const trackInitiatingGoogleSignIn = (authorizeUrl: string) => {
    logSSOFlow({
        stage: 'google-signin-initiated',
        url: sanitizeUrlForLogging(authorizeUrl, { stripQuery: true }),
        idpIdentifier: 'Google',
        success: true,
        metadata: {
            redirectUrl: sanitizeUrlForLogging(window.location.href, { stripQuery: true })
        }
    });
};
